export const API_FIXED_VENTA_URL =
  // "http://127.0.0.1:5001/fixeddesarrollo-8b589/southamerica-east1/apiFixed/ventaCrear";
  "https://southamerica-east1-fixedtesting-10ce2.cloudfunctions.net/apiFixed/ventaCrear";

export interface ApiFixedLineaVenta {
  cantidad: number;
  descripcion: string;
  descripcionLarga: string;
  rubro: string;
  tasaIva: string;
  descuentoMonto: number;
  precioUnitario: number;
}

/** Payload de cliente para Fixed (RUT = 2, cédula = 3). */
export interface ApiFixedClienteVenta {
  tipoDocumento: number;
  documento: string;
  razonSocial: string;
  nombreComercial: string;
  domicilio: string;
  localidad: string;
  departamento: string;
  domicilioEntrega: string;
  mailEnvioFactura: string;
  telefono: string;
  observaciones: string;
}

export interface ApiFixedVentaRequest {
  apiKey: string;
  rutComercio: string;
  cliente: ApiFixedClienteVenta | Record<string, never>;
  fecha: string;
  moneda: string;
  montoBruto: number;
  lineasVenta: ApiFixedLineaVenta[];
  observaciones: string;
  creadaDesde: "web" | "app";
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiFixedVentaResponse = any;

export const crearFacturaFixedVenta = async (
  payload: ApiFixedVentaRequest
): Promise<ApiFixedVentaResponse> => {
  const res = await fetch(API_FIXED_VENTA_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  const contentType = res.headers.get("content-type") ?? "";

  const out =
    contentType.includes("application/json") || contentType.includes("json")
      ? await res.json().catch(() => null)
      : await res.text().catch(() => null);

  if (!res.ok) {
    throw new Error(out.descripcion);
  }

  return out;
};
